import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propBool, propShape, propFunc, } from '../../../helpers/custom-prop-types';
import Hover from '../../Ui/System/Hover';
const ColumnComponentTocItem = (props) => {
    const { isLimit, item, onClick } = props;
    const { index, list = [], text } = item;
    return (_jsxs("li", { children: [_jsx(Hover, { children: isLimit ? (_jsx("span", Object.assign({ className: 'column_content_toc_item' }, { children: text }))) : (_jsx("button", Object.assign({ className: 'column_content_toc_item', onClick: onClick, type: 'button', value: index }, { children: text }))) }), list.length > 0 && (_jsx("ul", { children: list.map((h3) => (_jsx(ColumnComponentTocItem, { isLimit: isLimit, item: h3, onClick: onClick }, h3.index))) }))] }));
};
ColumnComponentTocItem.propTypes = {
    isLimit: propBool().isRequired,
    item: propShape().isRequired,
    onClick: propFunc().isRequired,
};
export default ColumnComponentTocItem;
